export default __webpack_public_path__ + "static/media/lowj4x.ae14dc5d.png";